// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__xPSn8","content":"style_content__RkCLr","button":"style_button__ksrDf","title":"style_title__tCBt2","info":"style_info__2DSfP"};